<script setup>
import { PrimaryButton } from '@codinglabsau/ui'
import ErrorLayout from '@/Layouts/ErrorLayout.vue'
import CategoryCard from '@/Components/Category/CategoryCard.vue'
import AuctionCard from '@/Components/Auction/AuctionCard.vue'
import ContentCategoryCard from '@/Components/Content/ContentCategoryCard.vue'
import ContentCard from '@/Components/Content/ContentCard.vue'
import StoreCard from '@/Components/Stores/StoreCard.vue'
import HelpCard from '@/Components/Help/HelpCard.vue'
import HelpCategoryCard from '@/Components/Help/HelpCategoryCard.vue'
import RouteCard from '@/Components/Errors/RouteCard.vue'
import hiding_gem from "@/../../public/assets/images/errors/hiding_gem.jpeg";
import ErrorWithImage from "@/Components/Errors/ErrorWithImage.vue";

const props = defineProps({
  suggestions: {
    type: Array,
  },
  suggestionsType: {
    type: String,
    default: 'Route',
    required: false,
  },
  indexRoute: {
    type: String,
    required: false,
  },
})

const componentMap = {
  Auction: AuctionCard,
  Category: CategoryCard,
  ContentCategory: ContentCategoryCard,
  Content: ContentCard,
  Store: StoreCard,
  Help: HelpCard,
  HelpCategory: HelpCategoryCard,
}

const gridClassMap = {
  Auction: 'grid-cols-2 sm:grid-cols-4',
  Category: 'grid-cols-2 sm:grid-cols-4',
  HelpCategory: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
  Route: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
}

const componentType = () => componentMap[props.suggestionsType] || RouteCard

const gridClasses = () => gridClassMap[props.suggestionsType] || 'grid-cols-1 sm:grid-cols-2'

</script>

<template>
  <ErrorLayout title="Page Not Found">
    <ErrorWithImage
      v-if="suggestions.length < 1"
      :heading="__('OOPs!')"
      :message="__('It looks like this page is hiding better than a rare gemstone!')"
      error="404"
      :image="hiding_gem"
    />
    <div class="py-12 space-y-10" v-else>
      <div class="flex">
        <div class="px-2 pt-6 md:pt-8 md:px-6 max-w-7xl w-full mx-auto">
          <p class="text-base font-semibold mb-4 leading-8 text-indigo-600">{{ __('Error 404') }}</p>
          <h1 class="font-bold text-5xl tracking-tight text-gray-900  sm:text-6xl">{{ __('Page Not Found') }}</h1>
          <p class="mt-6 text-lg md:text-xl leading-7 whitespace-normal text-gray-600">
            {{
              __('Looks like this page is hiding better than a rare gemstone. Let\'s dig you out of this and find the right page!')
            }}
          </p>
        </div>
      </div>
      <div class="mx-auto px-2 space-y-4 md:px-6 max-w-7xl">
        <h2 class="text-xl font-semibold">{{ __('Are these what you are looking for?') }}</h2>
        <div role="list" class="grid gap-4 not-prose" :class="gridClasses()">
          <component :is="componentType()"
                     v-for="suggestion in props.suggestions"
                     :key="suggestion.id"
                     :item="suggestion"
          />
        </div>
        <div v-if="indexRoute" class="flex justify-center">
          <PrimaryButton external :href="indexRoute" class="w-fit mt-8">
            {{ __('See More') }}
            &rarr;
          </PrimaryButton>
        </div>
      </div>
    </div>
  </ErrorLayout>
</template>
